@if (post(); as post) {
    <app-modal-bg (modalClick)="handleClose()">
        <div
            class="tw-modal-panel relative my-auto w-[min(640px,calc(100vw-2rem))] max-w-none overflow-hidden"
            role="dialog"
            aria-modal="true">

            <!-- Hero -->
            <figure class="relative h-[208px] w-full shrink-0 overflow-hidden">
                <img
                    class="absolute inset-0 h-full w-full object-cover"
                    appImageError
                    [alt]="post.imgData.alt"
                    [src]="post.imgData.src" />

                <!-- Bottom-up legibility gradient -->
                <div
                    class="pointer-events-none absolute inset-0 bg-gradient-to-b from-zinc-950/5 via-transparent to-zinc-950/70"
                    aria-hidden="true"></div>

                <!-- Brand halo (top-right) -->
                <div
                    class="pointer-events-none absolute inset-0 bg-[radial-gradient(120%_80%_at_100%_0%,rgba(49,87,218,0.28),transparent_60%)]"
                    aria-hidden="true"></div>

                <!-- Dot grid texture -->
                <div
                    class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.95)_1px,transparent_0)] bg-[length:18px_18px] opacity-[0.07] mix-blend-overlay"
                    aria-hidden="true"></div>

                <!-- Brand chip (top-left) -->
                <div
                    class="absolute left-4 top-4 inline-flex items-center gap-2 rounded-lg bg-white/95 px-2.5 py-1.5 shadow-[0_1px_2px_rgba(15,26,65,0.18),0_0_0_1px_rgba(15,26,65,0.05)] backdrop-blur-md">
                    <img
                        class="size-4 object-contain"
                        [alt]="post.imgIconData.alt"
                        [src]="post.imgIconData.src" />
                    <span class="text-[11.5px] font-semibold tracking-tight text-twTextPrimary">
                        Twinny
                    </span>
                </div>

                <!-- Glass close button (top-right) -->
                <button
                    type="button"
                    class="absolute right-4 top-4 flex size-8 items-center justify-center rounded-lg bg-white/90 text-zinc-600 shadow-[0_1px_2px_rgba(15,26,65,0.18),0_0_0_1px_rgba(15,26,65,0.05)] backdrop-blur-md transition-colors hover:bg-white hover:text-twTextPrimary"
                    aria-label="Close"
                    (click)="handleClose()">
                    <lucide-icon [img]="XIcon" [size]="14" [strokeWidth]="2" />
                </button>

                <!-- Meta strip (bottom of hero) -->
                <div class="absolute inset-x-0 bottom-0 flex flex-wrap items-center gap-2 px-5 pb-4">
                    <span
                        class="inline-flex items-center gap-1.5 rounded-md bg-white/95 px-2 py-0.5 text-[11.5px] font-semibold text-primary-700 shadow-[0_1px_2px_rgba(15,26,65,0.18)] ring-1 ring-inset ring-primary-100 backdrop-blur-md">
                        <lucide-icon [img]="SparklesIcon" [size]="12" [strokeWidth]="1.75" />
                        {{ post.version }}
                    </span>
                    <span
                        class="inline-flex items-center gap-1.5 text-[12px] font-medium tracking-tight text-white/95 drop-shadow-[0_1px_4px_rgba(0,0,0,0.65)]">
                        <lucide-icon [img]="CalendarIcon" [size]="13" [strokeWidth]="1.75" />
                        {{ post.releaseDate }}
                    </span>
                </div>
            </figure>

            <!-- Title strip -->
            <header
                class="flex shrink-0 flex-col gap-1.5 border-b border-zinc-200/70 bg-gradient-to-b from-zinc-50/60 to-transparent px-6 pb-5 pt-5">
                <span class="tw-section-label">
                    {{ 'dashboard.newsletter.modal.releaseNotes' | translate }}
                </span>
                <h2
                    class="text-[17px] font-semibold leading-tight tracking-[-0.01em] text-twTextPrimary">
                    {{ post.titleClean }}
                </h2>
                @if (post.description) {
                    <p class="mt-0.5 text-[13px] leading-snug text-zinc-500">
                        {{ post.description }}
                    </p>
                }
            </header>

            <!-- Scrollable body -->
            <div class="max-h-[360px] flex-grow overflow-y-auto px-6 py-5">
                <p
                    class="whitespace-pre-line text-[13.5px] leading-relaxed text-zinc-700">
                    {{ post.text }}
                </p>
            </div>

            <!-- Footer -->
            <footer
                class="flex shrink-0 items-center justify-between gap-3 rounded-b-2xl border-t border-zinc-200/70 bg-zinc-50/40 px-6 py-4">
                <span class="text-[12px] text-zinc-500">
                    {{ 'dashboard.newsletter.modal.fromTeam' | translate }}
                </span>
                <button type="button" class="tw-btn-primary" (click)="handleClose()">
                    {{ 'dashboard.newsletter.modal.gotIt' | translate }}
                </button>
            </footer>
        </div>
    </app-modal-bg>
}
